import { render, staticRenderFns } from "./Realogram.vue?vue&type=template&id=e3e8aaca&scoped=true&"
import script from "./Realogram.vue?vue&type=script&lang=js&"
export * from "./Realogram.vue?vue&type=script&lang=js&"
import style0 from "./Realogram.vue?vue&type=style&index=0&id=e3e8aaca&scoped=true&lang=css&"
import style1 from "./Realogram.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3e8aaca",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VBtn,VCard,VCardText,VChip,VCol,VDataTable,VIcon,VRow,VSelect,VTextField,VTooltip,VTreeview})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3e8aaca')) {
      api.createRecord('e3e8aaca', component.options)
    } else {
      api.reload('e3e8aaca', component.options)
    }
    module.hot.accept("./Realogram.vue?vue&type=template&id=e3e8aaca&scoped=true&", function () {
      api.rerender('e3e8aaca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Vision/Realogram.vue"
export default component.exports